<template>
	<div class="event-split2-popup">
		<b-row class="banner">
			<img
				@click="closeSlide"
				class="close2"
				src="@/assets/about/corner/btn_back.svg"
				alt=""
			/>
			<div class="row-grid" style="width: 100%">
				<div class="left-banner">
					<carousel
						:options="{ interval: 4000, duration: 1000, loop: true }"
						indicator="inside"
						control
						:key="EventData.pictures && EventData.pictures.length"
					>
						<template>
							<img
								src="/static/assets/program/activities/others/1/banner.jpg"
								width="100%"
							/>
						</template>
					</carousel>
				</div>
				<div class="scrollable">
					<div class="wrapper">
						<h1 class="title">
							2024 駐村藝術家專題講座：Malte Jehmlich (德國)
						</h1>
						<h2 class="date">▎活動時間：2024/10/9 (三)  19:00-20:00</h2>
						<h2 class="author">
							▎活動地點：蘭燈空間（宜蘭縣宜蘭市中山路一段662號）
						</h2>
					</div>
				</div>
			</div>
		</b-row>
		<div class="content">
			<p class="explain">
				《打造現場動畫電影！》偶戲藝術、圖像小說與動畫的融合之旅
			</p>
			<p class="explain">
				跨領域視覺藝術家 Malte Jehmlich（毛特．耶姆利希）在 10/9
				晚上於宜蘭市的「蘭燈空間」，以沉浸式講座和實作示範，帶領大家體驗一項獨特的藝術形式：現場動畫電影
				(LIVE ANIMATION CINEMA)！
			</p>
			<div class="grid">
				<img src="/static/assets/program/activities/others/1/1.jpg" />
				<img src="/static/assets/program/activities/others/1/2.jpg" />
				<img src="/static/assets/program/activities/others/1/3.jpg" />
				<img src="/static/assets/program/activities/others/1/4.jpg" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
	data() {
		return {
			scrolled: 0,
			EventData: {},
			_path: "",
		};
	},
	methods: {
		...mapActions(["getEventContent"]),
		onSlideStart(slide) {
			this.sliding = true;
		},
		onSlideEnd(slide) {
			this.sliding = false;
		},
		closeSlide() {
			this.$router.push("/program/activities");
		},
		timeConvert(timeStamp) {
			let date = new Date(timeStamp);
			let m = date.getMonth() + 1;
			let d = date.getDay();
			return m + "/" + d + " ";
		},
		handleScroll() {
			this.scrolled = window.scrollY;
		},
	},
	mounted() {
		this.getEventContent(this.$route.params.id).then(() => {
			this.EventData = this.$store.state.event;
		});
		this._path = window.location.href;
		setInterval(function () {
			$("iframe").attr("width", "100%");
			$("iframe").attr("height", "500px");
		}, 500);
	},
	components: {
		Carousel: () => import("../../components/Carousel"),
	},
	created() {
		window.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
.scrollable {
	.link {
		width: 100%;
	}
}
.content {
	max-width: 1200px;
	margin: 0 auto 60px;
}
.row-grid {
	.left-banner {
		width: 100%;
		@media screen and (min-width: 768px) {
			width: 50%;
		}
		position: relative;

		&::before {
			content: "";
			display: block;
			padding-top: 60%;
		}

		.carousel {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
	}
	.scrollable {
		flex: 1;
		background: #222222;
		color: #fff;
		line-height: 2;

		.wrapper {
			padding: 30px;
		}

		.title {
			font-size: 1.3em;
			margin: 20px 0;
		}

		@media screen and (min-width: 768px) {
			position: relative;
			overflow-y: auto;

			&::before {
				content: "";
				display: block;
				padding-top: 60%;
			}

			.wrapper {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
			}
		}
	}
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../../stylesheet/base.sass'
@import '../../stylesheet/layout.sass'

.event-split2-popup
  overflow: hidden
  position: relative
  width: 100%
  top: 0px
  left: 0
  .scroll-banner
    +flexLayout('between', 'row')
    position: fixed
    top: 90px
    left: 0
    width: 100%
    z-index: 100
    background-color: #222222
    color: white
    padding: 20px 130px
    flex-wrap: wrap
    height: 75px
    .link
      a
        font-size: 20px
        padding: 5px 10px
        margin-right: 10px
    @media screen and (max-width: 990px)
      height: 100px
      padding: 0
      +flexLayout('center', 'col')
      top: 91px

      .link
        margin-top: 12px
        a
          font-size: 16px
          padding: 5px 10px
          margin: 0
      .close
        position: absolute
        top: 23px
        right: 26px
    .title
      font-size: 24px !important
    .close
      +size(30px, 30px)
      z-index: 500
      opacity: 1
      @media screen and (max-width: 990px)
        top: 23px
        right: 26px
  .link a
    color: white
    padding: 18px 50px
    border-radius: 100px
    font-size: 24px
    background-color: #01b6e2
    @media screen and (max-width: 990px)
      margin-top: 15px
      padding: 5px 10px
      font-size: 18px
  .banner
    .banner-item
      word-wrap: break-word
      height: 480px
      line-height: 1.5
      letter-spacing: 2px
      .brief
        margin-bottom: 30px
      #carousel1
        .carousel-inner
          width: 100%
          height: 480px
        .carousel-item
          background-size: cover
          background-position: 50% 50%
          height: 480px
          width: 100%
      @media screen and (max-width: 990px)
        min-height: 300px
        height: initial
        #carousel1
          .carousel-inner
            width: 100%
            height: 300px
          .carousel-item
            background-size: cover
            background-position: 50% 50%
            height: 300px
            width: 100%

    .left
      background-color: white
      padding: 0
    .right
      background-color: $themeGray
      color: $white
      padding: 45px
      overflow-y: auto
      font-weight: 300
      .title
        font-size: $font-size-3
        margin: 20px 0
      .content
        font-size: $font-size-3-s
        line-height: 1.5
        letter-spacing: 3px
    .close2
      +size(30px, 30px)
      position: absolute
      right: 26px
      top: 45px
      z-index: 50
      opacity: 1
      transform: translateY(-50%)
  .content
    background-color: white
    padding: 50px 130px
    font-size: $font-size-3
    line-height: 1.5
    min-height: 1000px
  @media all and (max-width: 800px)
    .content
      padding: 50px 30px
  .share-box
    width: 100%
    padding: 0 40px
    line-height: 1.3
    letter-spacing: 2px
    max-width: 1000px
    margin: 30px auto

    img
      width: 30px
      height: 30px
      margin-right: 10px
</style>
<style lang="scss">
@import "../../stylesheet/base.sass";
@import "../../stylesheet/layout.sass";
.explain {
	max-width: 788px;
	width: 100%;
	font-size: $font-size-3-s;
	line-height: 2;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 20px;
	padding: 0 20px;
}

.grid {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(1, minmax(0, 1fr));
	gap: 0.5rem;
	max-width: 580px;
	margin-right: auto;
	margin-left: auto;
	margin-bottom: 100px;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
@media screen and (min-width: 769px) {
	.grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/program/program_activity_other_1.vue